"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var classnames = require("classnames");
var ui_1 = require("@vidazoo/ui");
var components_1 = require("./components");
var Login = /** @class */ (function (_super) {
    tslib_1.__extends(Login, _super);
    function Login(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onLogin = function (username, password) {
            var onLogin = _this.props.onLogin;
            onLogin(username, password);
        };
        _this.onVerifyToken = function (token) {
            var onVerifyToken = _this.props.onVerifyToken;
            onVerifyToken(token);
        };
        _this.onForgotPassword = function (email, token) {
            var onForgotPassword = _this.props.onForgotPassword;
            onForgotPassword(email, token);
        };
        _this.showForgotPassword = function (email) {
            _this.setState({
                login: false,
                forgotPassword: true,
                forgotEmail: email
            });
            var setTwoFactorAuthentication = _this.props.setTwoFactorAuthentication;
            setTwoFactorAuthentication(false);
        };
        _this.showLogin = function () {
            var _a = _this.props, resetForgotPassword = _a.resetForgotPassword, setTwoFactorAuthentication = _a.setTwoFactorAuthentication;
            resetForgotPassword();
            setTwoFactorAuthentication(false);
            _this.setState({
                login: true,
                forgotPassword: false
            });
        };
        _this.state = { mounted: false, login: true, forgotPassword: false, forgotEmail: "" };
        return _this;
    }
    Login.prototype.componentDidMount = function () {
        var _this = this;
        window.requestAnimationFrame(function () {
            _this.setState({ mounted: true });
        });
    };
    Login.prototype.getPageTitle = function () {
        var login = this.state.login;
        var _a = this.props, showTwoFactorAuthentication = _a.showTwoFactorAuthentication, pageTitle = _a.pageTitle;
        if (pageTitle) {
            return pageTitle;
        }
        return login ? "Login" : (showTwoFactorAuthentication ? "Two Factor Authentication" : "Forgot Password");
    };
    Login.prototype.renderLogo = function () {
        var renderLogo = this.props.renderLogo;
        if (typeof renderLogo === "function") {
            return renderLogo();
        }
        return renderLogo;
    };
    Login.prototype.renderIcon = function () {
        var renderIcon = this.props.renderIcon;
        if (typeof renderIcon === "function") {
            return renderIcon();
        }
        return renderIcon;
    };
    Login.prototype.renderLogin = function () {
        var _a = this.props, authError = _a.authError, authErrorMessage = _a.authErrorMessage, backgroundImageUrl = _a.backgroundImageUrl, loginTitle = _a.loginTitle, authErrorCode = _a.authErrorCode;
        var login = this.state.login;
        var style = {};
        if (backgroundImageUrl) {
            style.backgroundImage = "url(" + backgroundImageUrl + ")";
        }
        return (login ? React.createElement(components_1.LoginForm, { onLogin: this.onLogin, error: authError, errorMessage: authErrorMessage, onForgotPasswordClick: this.showForgotPassword, title: loginTitle, errorCode: authErrorCode }) : null);
    };
    Login.prototype.renderForgetPassword = function () {
        var _a = this.props, forgotPasswordError = _a.forgotPasswordError, recaptchaSiteKey = _a.recaptchaSiteKey, forgotPasswordLoading = _a.forgotPasswordLoading, forgotPasswordComplete = _a.forgotPasswordComplete, backgroundImageUrl = _a.backgroundImageUrl, forgotPasswordTitle = _a.forgotPasswordTitle, pageContainerClassName = _a.pageContainerClassName, surfaceClassName = _a.surfaceClassName;
        var _b = this.state, forgotPassword = _b.forgotPassword, forgotEmail = _b.forgotEmail;
        var style = {};
        if (backgroundImageUrl) {
            style.backgroundImage = "url(" + backgroundImageUrl + ")";
        }
        return (forgotPassword ? React.createElement(components_1.ForgotPasswordForm, { isLoading: forgotPasswordLoading, isComplete: forgotPasswordComplete, siteKey: recaptchaSiteKey, error: forgotPasswordError, onForgotPassword: this.onForgotPassword, onLoginClick: this.showLogin, title: forgotPasswordTitle, withEmail: forgotEmail }) : null);
    };
    Login.prototype.renderTwoFactorAuthentication = function () {
        var _a = this.props, verifyTokenError = _a.verifyTokenError, twoFactorTitle = _a.twoFactorTitle, setTwoFactorAuthentication = _a.setTwoFactorAuthentication, recaptchaSiteKey = _a.recaptchaSiteKey, onRequestTwoFactorToken = _a.onRequestTwoFactorToken;
        return (React.createElement(components_1.TwoFactorForm, { setTwoFactorAuthentication: setTwoFactorAuthentication, onLoginClick: this.showLogin, onVerifyToken: this.onVerifyToken, onRequestTwoFactorToken: onRequestTwoFactorToken, error: verifyTokenError, title: twoFactorTitle, siteKey: recaptchaSiteKey }));
    };
    Login.prototype.renderForm = function () {
        var showTwoFactorAuthentication = this.props.showTwoFactorAuthentication;
        if (showTwoFactorAuthentication) {
            return this.renderTwoFactorAuthentication();
        }
        else {
            return React.createElement(React.Fragment, null,
                this.renderLogin(),
                this.renderForgetPassword());
        }
    };
    Login.prototype.render = function () {
        var _a;
        var _b = this.props, backgroundImageUrl = _b.backgroundImageUrl, pageContainerClassName = _b.pageContainerClassName, surfaceClassName = _b.surfaceClassName, isTemplate = _b.isTemplate, children = _b.children;
        var mounted = this.state.mounted;
        var classes = classnames(theme.login, (_a = {},
            _a[theme.mounted] = mounted,
            _a), pageContainerClassName);
        var surfaceClasses = classnames(theme.surface, surfaceClassName);
        var style = {};
        if (backgroundImageUrl) {
            style.backgroundImage = "url(" + backgroundImageUrl + ")";
        }
        return (React.createElement(ui_1.PageContainer, { pageTitle: this.getPageTitle(), className: classes, style: style },
            React.createElement(ui_1.Surface, { level: 2, className: surfaceClasses },
                React.createElement("div", { className: theme.window },
                    React.createElement("div", { className: theme.logo },
                        React.createElement("div", { className: theme.bannerWrapper }, this.renderLogo()),
                        React.createElement("div", { className: theme.icon }, this.renderIcon())),
                    !isTemplate ? this.renderForm() :
                        React.createElement(React.Fragment, null, children)))));
    };
    Login.defaultProps = {};
    return Login;
}(React.Component));
exports.default = Login;
